import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _50875a68 = () => interopDefault(import('../pages/applypass/index.vue' /* webpackChunkName: "pages/applypass/index" */))
const _510c2372 = () => interopDefault(import('../pages/auth.vue' /* webpackChunkName: "pages/auth" */))
const _109cc93a = () => interopDefault(import('../pages/banjo.vue' /* webpackChunkName: "pages/banjo" */))
const _35773c7c = () => interopDefault(import('../pages/banjo-home.vue' /* webpackChunkName: "pages/banjo-home" */))
const _022d6758 = () => interopDefault(import('../pages/browser-update.vue' /* webpackChunkName: "pages/browser-update" */))
const _2300db62 = () => interopDefault(import('../pages/company-article/index.vue' /* webpackChunkName: "pages/company-article/index" */))
const _7122472e = () => interopDefault(import('../pages/company-search-results/index.vue' /* webpackChunkName: "pages/company-search-results/index" */))
const _0357bf14 = () => interopDefault(import('../pages/discover/index.vue' /* webpackChunkName: "pages/discover/index" */))
const _e0ad00a4 = () => interopDefault(import('../pages/error.vue' /* webpackChunkName: "pages/error" */))
const _7cf49fab = () => interopDefault(import('../pages/forgot-password.vue' /* webpackChunkName: "pages/forgot-password" */))
const _429a71ae = () => interopDefault(import('../pages/home.vue' /* webpackChunkName: "pages/home" */))
const _3cd738ac = () => interopDefault(import('../pages/job-match-feedback/index.vue' /* webpackChunkName: "pages/job-match-feedback/index" */))
const _acee6cba = () => interopDefault(import('../pages/jobs/index.vue' /* webpackChunkName: "pages/jobs/index" */))
const _6e2220b9 = () => interopDefault(import('../pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _77e28080 = () => interopDefault(import('../pages/my-searches/index.vue' /* webpackChunkName: "pages/my-searches/index" */))
const _1ad5229e = () => interopDefault(import('../pages/not-found/index.vue' /* webpackChunkName: "pages/not-found/index" */))
const _376de1f9 = () => interopDefault(import('../pages/one-auth.vue' /* webpackChunkName: "pages/one-auth" */))
const _4bee1962 = () => interopDefault(import('../pages/profile.vue' /* webpackChunkName: "pages/profile" */))
const _55c5f5c4 = () => interopDefault(import('../pages/reset-email.vue' /* webpackChunkName: "pages/reset-email" */))
const _924a4fba = () => interopDefault(import('../pages/reset-password.vue' /* webpackChunkName: "pages/reset-password" */))
const _3ca8a6f4 = () => interopDefault(import('../pages/resume-writing.vue' /* webpackChunkName: "pages/resume-writing" */))
const _4770b21c = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _382835de = () => interopDefault(import('../pages/search-results/index.vue' /* webpackChunkName: "pages/search-results/index" */))
const _26e01470 = () => interopDefault(import('../pages/set-password.vue' /* webpackChunkName: "pages/set-password" */))
const _409c636d = () => interopDefault(import('../pages/settings.vue' /* webpackChunkName: "pages/settings" */))
const _26c73bd2 = () => interopDefault(import('../pages/signout.vue' /* webpackChunkName: "pages/signout" */))
const _7881930b = () => interopDefault(import('../pages/smart-login.vue' /* webpackChunkName: "pages/smart-login" */))
const _e01eca8c = () => interopDefault(import('../pages/unsubscribe/index.vue' /* webpackChunkName: "pages/unsubscribe/index" */))
const _4c91756f = () => interopDefault(import('../pages/update-profile.vue' /* webpackChunkName: "pages/update-profile" */))
const _510673cd = () => interopDefault(import('../pages/job-match-feedback/thankyou.vue' /* webpackChunkName: "pages/job-match-feedback/thankyou" */))
const _331b894b = () => interopDefault(import('../pages/notifications/saved-searches-freq/index.vue' /* webpackChunkName: "pages/notifications/saved-searches-freq/index" */))
const _4eb26710 = () => interopDefault(import('../pages/notifications/subscriptions/index.vue' /* webpackChunkName: "pages/notifications/subscriptions/index" */))
const _4cface9e = () => interopDefault(import('../pages/static/privacy.vue' /* webpackChunkName: "pages/static/privacy" */))
const _8915d120 = () => interopDefault(import('../pages/static/terms.vue' /* webpackChunkName: "pages/static/terms" */))
const _639bba86 = () => interopDefault(import('../pages/unsubscribe/thankyou.vue' /* webpackChunkName: "pages/unsubscribe/thankyou" */))
const _62fdacb8 = () => interopDefault(import('../pages/job/expired/_id.vue' /* webpackChunkName: "pages/job/expired/_id" */))
const _0483c5e2 = () => interopDefault(import('../pages/browse/_slug.vue' /* webpackChunkName: "pages/browse/_slug" */))
const _06c501a4 = () => interopDefault(import('../pages/discover/_slug.vue' /* webpackChunkName: "pages/discover/_slug" */))
const _f3f350ee = () => interopDefault(import('../pages/job-preview/_id.vue' /* webpackChunkName: "pages/job-preview/_id" */))
const _155c7861 = () => interopDefault(import('../pages/job-redirect/_id.vue' /* webpackChunkName: "pages/job-redirect/_id" */))
const _244fc86e = () => interopDefault(import('../pages/jobview/_slug/_id.vue' /* webpackChunkName: "pages/jobview/_slug/_id" */))
const _75e08796 = () => interopDefault(import('../pages/discover/_slug' /* webpackChunkName: "" */))
const _99795992 = () => interopDefault(import('../pages/company-article/index' /* webpackChunkName: "" */))
const _a2064ace = () => interopDefault(import('../pages/static/privacy' /* webpackChunkName: "" */))
const _334290d8 = () => interopDefault(import('../pages/static/terms' /* webpackChunkName: "" */))
const _6a91f5de = () => interopDefault(import('../pages/home' /* webpackChunkName: "" */))
const _3c094f96 = () => interopDefault(import('../pages/company-search-results/index' /* webpackChunkName: "" */))
const _766b0cde = () => interopDefault(import('../pages/discover/index' /* webpackChunkName: "" */))
const _0b3d315a = () => interopDefault(import('../pages/search' /* webpackChunkName: "" */))
const _319bd374 = () => interopDefault(import('../pages/search-results/index' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/jobs/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/applypass",
    component: _50875a68,
    name: "applypass"
  }, {
    path: "/auth",
    component: _510c2372,
    name: "auth"
  }, {
    path: "/banjo",
    component: _109cc93a,
    name: "banjo"
  }, {
    path: "/banjo-home",
    component: _35773c7c,
    name: "banjo-home"
  }, {
    path: "/browser-update",
    component: _022d6758,
    name: "browser-update"
  }, {
    path: "/company-article",
    component: _2300db62,
    name: "company-article"
  }, {
    path: "/company-search-results",
    component: _7122472e,
    name: "company-search-results"
  }, {
    path: "/discover",
    component: _0357bf14,
    name: "discover"
  }, {
    path: "/error",
    component: _e0ad00a4,
    name: "error"
  }, {
    path: "/forgot-password",
    component: _7cf49fab,
    name: "forgot-password"
  }, {
    path: "/home",
    component: _429a71ae,
    name: "home"
  }, {
    path: "/job-match-feedback",
    component: _3cd738ac,
    name: "job-match-feedback"
  }, {
    path: "/jobs",
    component: _acee6cba,
    name: "jobs"
  }, {
    path: "/maintenance",
    component: _6e2220b9,
    name: "maintenance"
  }, {
    path: "/my-searches",
    component: _77e28080,
    name: "my-searches"
  }, {
    path: "/not-found",
    component: _1ad5229e,
    name: "not-found"
  }, {
    path: "/one-auth",
    component: _376de1f9,
    name: "one-auth"
  }, {
    path: "/profile",
    component: _4bee1962,
    name: "profile"
  }, {
    path: "/reset-email",
    component: _55c5f5c4,
    name: "reset-email"
  }, {
    path: "/reset-password",
    component: _924a4fba,
    name: "reset-password"
  }, {
    path: "/resume-writing",
    component: _3ca8a6f4,
    name: "resume-writing"
  }, {
    path: "/search",
    component: _4770b21c,
    name: "search"
  }, {
    path: "/search-results",
    component: _382835de,
    name: "search-results"
  }, {
    path: "/set-password",
    component: _26e01470,
    name: "set-password"
  }, {
    path: "/settings",
    component: _409c636d,
    name: "settings"
  }, {
    path: "/signout",
    component: _26c73bd2,
    name: "signout"
  }, {
    path: "/smart-login",
    component: _7881930b,
    name: "smart-login"
  }, {
    path: "/unsubscribe",
    component: _e01eca8c,
    name: "unsubscribe"
  }, {
    path: "/update-profile",
    component: _4c91756f,
    name: "update-profile"
  }, {
    path: "/job-match-feedback/thankyou",
    component: _510673cd,
    name: "job-match-feedback-thankyou"
  }, {
    path: "/notifications/saved-searches-freq",
    component: _331b894b,
    name: "notifications-saved-searches-freq"
  }, {
    path: "/notifications/subscriptions",
    component: _4eb26710,
    name: "notifications-subscriptions"
  }, {
    path: "/static/privacy",
    component: _4cface9e,
    name: "static-privacy"
  }, {
    path: "/static/terms",
    component: _8915d120,
    name: "static-terms"
  }, {
    path: "/unsubscribe/thankyou",
    component: _639bba86,
    name: "unsubscribe-thankyou"
  }, {
    path: "/job/expired/:id?",
    component: _62fdacb8,
    name: "job-expired-id"
  }, {
    path: "/browse/:slug?",
    component: _0483c5e2,
    name: "browse-slug"
  }, {
    path: "/discover/:slug",
    component: _06c501a4,
    name: "discover-slug"
  }, {
    path: "/job-preview/:id?",
    component: _f3f350ee,
    name: "job-preview-id"
  }, {
    path: "/job-redirect/:id?",
    component: _155c7861,
    name: "job-redirect-id"
  }, {
    path: "/jobview/:slug?/:id?",
    component: _244fc86e,
    name: "jobview-slug-id"
  }, {
    path: "/my-activity/:slug",
    component: _75e08796,
    name: "my-activity-slug"
  }, {
    path: "/my-searches/:slug",
    component: _75e08796,
    name: "my-searches-slug"
  }, {
    path: "/jobs/:filters?/article/:article",
    component: _99795992,
    name: "company-article"
  }, {
    path: "/privacy",
    component: _a2064ace
  }, {
    path: "/terms",
    component: _334290d8
  }, {
    path: "/",
    component: _6a91f5de,
    name: "home"
  }, {
    path: "/*/:brand(.*br_.*)",
    component: _3c094f96,
    name: "company-search-results"
  }, {
    path: "/discover/",
    component: _766b0cde,
    name: "discover"
  }, {
    path: "/search/",
    component: _0b3d315a,
    name: "search"
  }, {
    path: "/*",
    component: _319bd374,
    name: "default-search-results"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
